<template>
    <section class="testing-nrk-component section">
        <div class="section__header">
            <h3 class="section__title">{{ getTranslation('nrkResources') }} - {{ pagination.total }}</h3>
        </div>
        <div class="section__body">
            <table class="table-3 table-borderless">
                <thead class="table-3__head">
                    <tr class="table-3__row">
                        <td colspan="2" class="table-3__cell  table__hcell">
                            <form @submit.prevent="getNrkPositions">
                                <input v-model="filterForm.query" type="text" class="form-control" :placeholder="getTranslation('searchByName')" />
                            </form>
                        </td>
                        <td class="table-3__cell">
                            <button @click="getNrkPositions" class="btn  btn--sm  btn--main">{{getTranslation('search')}}</button>
                        </td>
                    </tr>
                    <tr class="table-3__row">
                        <th class="table-3__cell  table__hcell" style="width: 0.1%;">#</th>
                        <th class="table-3__cell  table__hcell" style="width: 20%;">{{ getTranslation('title') }}</th>
                        <th class="table-3__cell  table__hcell" style="width: 25%;">{{ getTranslation('category') }}</th>
                    </tr>
                </thead>
                <tbody class="table-3__body">
                    <tr v-for="item in  items" v-bind:key="item.id" class="table-3__row">
                        <td class="table-3__cell">
                            <strong>{{item.id}}</strong>
                        </td>
                        <td class="table-3__cell">
                            <router-link :to="{name:'api.nrk.resource.get',params:{id:item.id}}">{{ item.title }}</router-link>
                        </td>
                        <td class="table-3__cell">
                            {{ item.resourceTitle }}
                        </td>
                    </tr>
                    <tr v-if="items.length < 1" class="table-3__row">
                        <td colspan="5" class="table-3__cell empty">
                            {{ getTranslation('notAddedYet') }}
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div class="page-layout__pagination" v-if="pagination.total && pagination.lastPage > 1">
            <pagination :pagination="pagination" @change="()=>{this.getNrkPositions();this.$scrollTo('.testing-nrk-component');}" v-model="filterForm.page"></pagination>
        </div>

        <!-- modal addPosition -->
        <modal
                v-model="showModal"
                :modal-title="getTranslation('addNrkResource')"
                :ok-button-label="getTranslation('save')"
                :cancel-button-label="getTranslation('cancel')"
                @ok-button-click="addPositionResource"
                @cancelButtonClick="resetModal"
                @input="resetModal"
        >

            <div v-if="showResource" class="form__group">
                <label class="form__label  form__label--block">{{ getTranslation('position') }}<span class="required">*</span></label>
                <v-select
                        :options="resources"
                        :reduce="option=>option.id"
                        label="title"
                        :placeholder="getTranslation('selectFromList')"
                        :class="{'field--error':$v.form.resourceId.$error}"
                        v-model="form.resourceId"
                />
                <div v-if="$v.form.resourceId.$error" class="form__error">{{ getTranslation('requiredField') }}</div>
            </div>

        </modal>

    </section>
</template>

<script>
    import testingProfileMixin from "../mixins/testingProfile";
    import required from "vuelidate/lib/validators/required";
    import nrkMixin from "../../nrk/mixins/nrk";

    export default {
        name: "NrkResources",
        mixins: [testingProfileMixin, nrkMixin],
        props: {
            testId: {
                required: true
            },
            active: {
                default: false
            }
        },
        data() {
            return {
                items: [],
                showModal: false,
                showResource: false,
                resources: [],
                form: {
                    resourceId: '',
                    resourceType: '',
                    testId: '',
                },
                filterForm: {
                    page: this.$route.query.page || 1,
                },
                pagination: {
                    total: '',
                    lastPage: '',
                    currentPage: ''
                },
            }
        },
        created() {
            if ( this.active )
                this.getNrkPositions();
        },
        watch: {
            'active'( val ) {
                if ( val )
                    this.getNrkPositions();
            },
        },
        methods: {
            getNrkPositions() {

                this.filterForm = this.cleanObject( this.filterForm );

                this.fetchNrkPositions( this.testId, this.filterForm ).then( response => {

                    this.items = response.items;

                    this.filterForm.page = response.activePage;

                    this.pagination.currentPage = response.activePage;
                    this.pagination.total = response.totalItemsCount;
                    this.pagination.lastPage = response.pages;

                } )
            },

            addPositionResource() {

                this.form.testId = this.testId;

                this.$v.form.$touch();

                if ( this.$v.form.$invalid )
                    return this.snotifyError( 'wrongFormMsg' );

                this.addResource( this.form )
                    .then( () => {
                        this.getNrkPositions();
                        this.resetModal();
                    } )


            },

            removePositionResource( resource ) {
                let form = {
                    resourceId: resource.id,
                    resourceType: resource.type.id,
                    testId: this.testId
                };

                this.removeResource( form );
            },

            openModal() {

            },
            resetModal() {
                this.$v.$reset();
                this.form.resourceType = '';
                this.form.resourceId = '';
                this.form.testId = this.testId;
                this.showModal = false;
                this.showResource = false;
            }
        },
        validations: {

            form: {
                resourceId: {
                    required
                },
                resourceType: {
                    required
                },
                testId: {
                    required
                }
            }
        }
    }
</script>

<style scoped>

</style>
